import { render, staticRenderFns } from "./TabSwitch.vue?vue&type=template&id=2938e7ee&"
import script from "./TabSwitch.js?vue&type=script&lang=js&"
export * from "./TabSwitch.js?vue&type=script&lang=js&"
import style0 from "./TabSwitch.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports